import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-historique-carriere',
  templateUrl: './historique-carriere.component.html',
  styleUrls: ['./historique-carriere.component.css']
})

export class HistoriqueCarriereComponent implements OnInit {

  @Input() CARRIERE: any
  public arrayResponseCarriere: any = [];
  public listQuestion: any;
  public typeVisualisation: any;
  public response: any;
  public typeFiche: any;
  public entretien_id: string;
  public agent_id: string;
  public typeSauvegarde: any;
  public API_URL: any;
  public vueActive: any;
  public statut: any;
  constructor() { }

  ngOnInit() {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    // console.log('URL IS :', url);
    // console.log('typeFiche IS :', this.typeFiche);
    // console.log('typeSauvegarde IS :', this.typeSauvegarde);
    // console.log('typeVisualisation IS :', this.typeVisualisation);
    // console.log('statut IS :', this.statut);
    // console.log('vueActive IS :', this.vueActive);
    // console.log('entretien_id IS :', this.entretien_id);
    // console.log('agent_id IS :', this.agent_id);
    this.getCarrieres();
  }

  getCarrieres() {
    this.listQuestion = this.CARRIERE;
  }

}
